import { Box, Button, IconButton, Typography } from "@mui/material"
import { useCallback, useMemo, useRef } from "react"
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import { enqueueSnackbar } from "notistack";

export default function UploadFile({
    values,
    onChangeValues,
    type = "formulario",
    multiple = true,
    btnActionsList = []
}: UploadFileProps) {

    const fileInputRef = useRef<HTMLInputElement>(null);

    //funções manipuladoras
    const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const arquivosSelecionados = event.target.files ? Array.from(event.target.files) : [];
    
        if (arquivosSelecionados.length) {
            let arquivosParaAdicionar: File[] = [];
            
            arquivosSelecionados.forEach(novoArquivo => {
                const arquivoExiste = values.some(arquivo => arquivo.name === novoArquivo.name);
    
                if (!arquivoExiste) {
                    arquivosParaAdicionar.push(novoArquivo);
                } else {
                    enqueueSnackbar(`Arquivo ${novoArquivo.name} com mesmo nome já foi adicionado`, {
                        variant: "warning"
                    });
                }
            });
    
            if (arquivosParaAdicionar.length) {
                onChangeValues([...values, ...arquivosParaAdicionar]);
            }
        }
    }, [values, onChangeValues]);

    const handleRemoveFile = useCallback((fileName: string) => {
        onChangeValues(values.filter(file => file.name !== fileName));
    }, [values, onChangeValues]);

    const handleClick = useCallback(() => {
        if (fileInputRef.current) fileInputRef.current.click();
    }, []);
    //

    const InputFile = useMemo(() => (
        <>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                multiple={multiple}
            />

        {
            (multiple || values.length === 0) &&
            <Button
                variant="outlined"
                startIcon={<CloudUploadIcon />}
                onClick={handleClick}
                sx={{
                    textTransform: 'none'
                }}
            >
                Adicionar arquivo{multiple ? '(s)' : '' }
            </Button>
            }
        </>
    ), [handleClick, handleFileChange, multiple, values])

    if (values.length <= 0 && type === "formulario") return (
        <Box
            width="100%"
            height={140}
            border="1px solid #ccc"
            borderRadius={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            {InputFile}
        </Box>
    )

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                mb={2}
            >
                {
                    values.map((file, index) => {
                        return (
                            <Box
                                py={1}
                                key={index}
                                display="inherit"
                                justifyContent="space-between"
                                alignItems="center"
                                borderBottom="1px solid #ccc"
                            >
                                <Box display="inherit" gap={1} alignItems="center">
                                    <AttachFileIcon />
                                    <Typography variant="subtitle2">{file.name}</Typography>
                                </Box>

                                <IconButton
                                    aria-label="delete"
                                    onClick={() => handleRemoveFile(file.name)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                        )
                    })
                }
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
                {
                    btnActionsList.map((btn) => btn)
                }
                {InputFile}
            </Box>
        </>
    )
}

interface UploadFileProps {
    values: File[],
    multiple?: boolean,
    onChangeValues: (arg: File[]) => void,
    type?: "formulario" | "tarefa",
    btnActionsList?: JSX.Element[]
}